import moment from 'moment';

$(function(){
  $(document).on('click', '.deck_search_card_filter-remove', function (e) {
    $(e.target).closest('.row').remove();
  });
  $("#deck_search_card_filter-new").click(function (e) {
    var input = $('#deck_search_card_filter-counter');
    //var template_counter = $('#deck_search_card_filter-template_counter').val();
    var new_index = input.val();
    input.val(+input.val() + 1);
    var fragment = $("#deck_search_card_filter-template").children().first().clone();
    fragment.find(':input').each(function(){
      if ($(this).is("[name]")) {
        $(this).attr("name", $(this).attr("name").replace($(this).attr("name").match(/\[[0-9]+\]/), "["+new_index+"]"));
      }
      if ($(this).is("[id]")) {
        $(this).attr("id", $(this).attr("id").replace($(this).attr("id").match(/_[0-9]+_/), "_"+new_index+"_"));
      }
    });
    fragment.find('label').each(function(){
      if ($(this).is("[for]")) {
        $(this).attr("for", $(this).attr("for").replace($(this).attr("for").match(/_[0-9]+_/), "_"+new_index+"_"));
      }
    });
    fragment.appendTo("#deck_search_card_filter-container");
    // rebind the autocomplete
    bindAutoCompleteCard();
  });
});
